<template>
	<div>
		
		<Button type="error" size="small" style="margin-right: 5px"  @click="qinglingAll()">全部清零</Button>	
		<div class="query">
			<div class="checkbox">
				<Select v-model="query.rank" style="width:200px" @on-change="onchange">
					<Option v-for="item in ranks" :value="item.rank" :key="item.rank">{{ item.title }}</Option>
				</Select>
			</div>
			<Input search enter-button placeholder="请输入url" v-model="query.url" style="width: 500px;"  @on-search="onsearch"/>
		</div>
		<Table border :columns="columns12" :data="data6" :loading="loading">
			<template slot-scope="{ row, index }" slot="action">
				
				<Button type="error" size="small" style="margin-right: 5px"  @click="qingling(row.id)">清零</Button>
			</template>
		</Table>
		<div class="my-page">
			<page :total="total" v-if="showPage" @updatePage="updatePage" @updateSize="updateSize"></page>
		</div>
	</div>
</template>
<script>
	import http from '@/http/http.js'
	import page from '@/components/comm/page.vue'
	export default {
		data() {
			return {
				showPage:true,
				ranks:[
					{rank:'max',title:'最长时间降序'},
					{rank:'average',title:'平均时间降序'},
					{rank:'number',title:'访问次数降序'},
				],
				units:[],
				loading: false,
				total: 0,
				query: { //查询参数
					page: 0,
					size: 10,
					url:'',
					rank:'max'
				},
				number:'',
				unitId:'',
				columns12: [{
						type: 'selection',
						width: 60,
						align: 'center'
					}, {
						title: 'id',
						key: 'id'
					},
					{
						title: 'url',
						key: 'url'
					},
					{
						title: '最短时间(单位：ms)',
						key: 'min'
					},
					{
						title: '最长时间(单位：ms)',
						key: 'max'
					},
					{
						title: '平均时间(单位：ms)',
						key: 'average'
					},
					
					{
						title: '请求次数',
						key: 'number'
					},
					{
						title: '清零时间',
						key: 'createdTime'
					},
					{
						title: '操作',
						slot: 'action',
						width: 100,
						align: 'center'
					}
				],
				data6: [
					
				]

			}
		},
		methods: {
			ret() { //返回上一页
				this.$router.go(-1)
			},
			onchange(){
				this.query.page=0
				//重新渲染子组件
				this.showPage = false
				this.$nextTick(() => {
					this.showPage = true
				}) 
				this.ajaxPage()
			},
			updatePage(page) { //页码改变的回调，返回改变后的页码
				this.query.page = page - 1
				this.ajaxPage()
			},
			updateSize(size) { //切换每页条数时的回调，返回切换后的每页条数
				this.query.size = size
				this.ajaxPage()
			},
			onsearch(){
				this.query.page=0
				//重新渲染子组件
				this.showPage = false
				this.$nextTick(() => {
					this.showPage = true
				}) 
				this.ajaxPage()
			},
			ajaxPage() {
				this.loading = true
				let _this=this
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/responseUrl/page',
				    data: _this.query,
					_this: _this,
					success: function(data) {
						_this.total = data.page.totalElements
						_this.data6 = data.page.content
						
						_this.loading = false
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })
				
			},
			qingling(id){
				let _this=this
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/responseUrl/empty',
				    data: {id:id},
					_this: _this,
					success: function(data) {
						_this.ajaxPage()
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })
			},
			qinglingAll(){
				let _this=this
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/responseUrl/empty/all',
				    data: {},
					_this: _this,
					success: function(data) {
						_this.ajaxPage()
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })
			}

		},
		components: {
			page
		},
		created() {
			this.ajaxPage();
		}


	}
</script>
<style scoped="scoped">
	.ivu-table-cell {
		padding-left: 0px !important;
	}

	.list-btn {
		margin-bottom: 20px;
	}

	.delete {
		/* background-color: red;
		color: #333333; */
	}

	.my-page {
		display: flex;
		justify-content: flex-end;
		margin-top: 20px;
	}

	.ivu-table-cell {
		padding-left: 0px;
	}

	.query {
		display: flex;
		justify-content: space-between;
		margin: 20px 0px 20px 0px;
	}
</style>



// WEBPACK FOOTER //
// src/components/jm/admin/responseTime/list1.vue